module.exports = __webpack_public_path__ + "static/fonts/NotoSansThai-VariableFont_wdth,wght.aa3bdcb.ttf";